module.exports = __webpack_public_path__ + "static/avatare-0d71125638dffb96df508bf666cd1bd1.png";